<div class="successPayment" role="main" aria-label="Application success page">
    <img src="/assets/images/success.svg" alt="Application submitted successfully">
    <h3 [appTranslate]="'APP_SUCCESS'"></h3>

    <div>
        <button type="button" class="btn btn-next" (click)="goToDashboard()" [appTranslate]="'MY_REQUIREMENTS'" aria-label="Go to my requirements"></button>
    </div>
</div>